import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { ReadMoreProps } from "./ReadMore.types";
import { AllHtmlEntities } from "html-entities";

const allHtmlEntities = new AllHtmlEntities();

export const ReadMore: React.FC<ReadMoreProps> = ({
  text = "",
  limit = 200,
  readMoreText = "read more",
  readLessText = "read less",
  onClickRead,
  stopPropagation = true,
  defaultOpen = false,
  ...rest
}) => {
  const hasLimit = limit > 0;

  const strippedText = text.replace(/(<([^>]+)>)/gi, "");
  const lessText = allHtmlEntities.decode(strippedText).substr(0, limit);
  const textLength = (strippedText || "").length;
  const [readMore, setReadMore] = useState(
    defaultOpen || !hasLimit || textLength < limit,
  );
  return (
    <Box as="div" {...rest}>
      {hasLimit && textLength > limit && !readMore && lessText + "..."}
      {(!hasLimit || textLength <= limit || readMore) && (
        <div
          className={"dangerous-react-more-wrapper"}
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      )}
      {hasLimit && textLength > limit && (
        <Box
          cursor="pointer"
          as="span"
          fontWeight="700"
          textDecoration="underline"
          onClick={(e) => {
            if (stopPropagation) {
              e.preventDefault();
              e.stopPropagation();
            }
            if (onClickRead) {
              return onClickRead();
            }
            setReadMore(!readMore);
          }}
        >
          {readMore ? readLessText : readMoreText}
        </Box>
      )}
    </Box>
  );
};
